import React from "react";
import { useGetBanners } from "../../hooks/useSettingsQueries";
import Banners from "../../components/Banners/Banners";

export default function BannersPage() {
  const { isLoading, data: banners } = useGetBanners();
  return (
    <div className="black-page d-flex flex-column">
      <Banners loading={isLoading} data={banners} />
    </div>
  );
}
